export default "__VITE_ASSET__DKDYsDzo__"